export function getdata(){
	var obj = {
			headData: [{
				title: "房产税",
				children: [{
					title: "序号",
					prop: "groud",
					custom: true,
				}, {
					title: "房产编号",
					prop: "ccxwfc_1_x_1",
					
					custom: true,
				}, {
					title: "税款所属期起",
					prop: "ccxwfc_1_x_2",
					
					custom: true,
				}, {
					title: "税款所属期止",
					prop: "ccxwfc_1_x_3",
					
					custom: true,
				}, {
					title: "减免性质代码和项目名称",
					prop: "ccxwfc_1_x_4",
					custom: true,
				}, {
					title: "减免税额",
					prop: "ccxwfc_1_x_5",
					
					custom: true,
				}]
			}, ],
			tableData: [{
				groud: 1,
				disabledccxwfc_1_x_1: false,
				disabledccxwfc_1_x_2: false,
				disabledccxwfc_1_x_3: false,
				disabledccxwfc_1_x_4: false,
				disabledccxwfc_1_x_5: false,
				ccxwfc_1_x_1: {
					cellCode: "ccxwfc_1_b1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_2: {
					cellCode: "ccxwfc_1_b1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_3: {
					cellCode: "ccxwfc_1_b1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_4: {
					cellCode: "ccxwfc_1_b1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_5: {
					cellCode: "ccxwfc_1_b1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
		
			}, {
				groud: 2,
				disabledccxwfc_1_x_1: false,
				disabledccxwfc_1_x_2: false,
				disabledccxwfc_1_x_3: false,
				disabledccxwfc_1_x_4: false,
				disabledccxwfc_1_x_5: false,
				ccxwfc_1_x_1: {
					cellCode: "ccxwfc_1_b2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_2: {
					cellCode: "ccxwfc_1_b2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_3: {
					cellCode: "ccxwfc_1_b2_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_4: {
					cellCode: "ccxwfc_1_b2_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_5: {
					cellCode: "ccxwfc_1_b2_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				groud: '小计',
				disabledccxwfc_1_x_1: false,
				disabledccxwfc_1_x_2: false,
				disabledccxwfc_1_x_3: false,
				disabledccxwfc_1_x_4: false,
				disabledccxwfc_1_x_5: false,
				ccxwfc_1_x_1: {
					cellCode: "ccxwfc_1_b3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_2: {
					cellCode: "ccxwfc_1_b3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_3: {
					cellCode: "ccxwfc_1_b3_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_4: {
					cellCode: "ccxwfc_1_b3_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwfc_1_x_5: {
					cellCode: "ccxwfc_1_b3_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}],
	}
	return obj
}
